module.exports = __webpack_public_path__ + "img/edit_green.ec17558e.svg";